var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobsiteHubColor02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00205b;}.cls-2{fill:#009639;}.cls-3{fill:#545859;}.cls-4{fill:#d9d9d6;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    className: "cls-4",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Jobsite_Hub_v02"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 100,
    cy: 61.05,
    r: 11.11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.22 68.36 58.22 68.37 58.25 68.36 58.22 68.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m58.22,68.37l-34.03,13.6c-2.53,1.03-4.19,3.47-4.19,6.19v75.22c0,4.72,4.75,7.94,9.14,6.19l35.31-14.14v-69.83c-.97-1.92-1.86-3.83-2.67-5.72-1.55-3.66-2.89-7.6-3.55-11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m100,29.94c-18.42,0-33.33,14.92-33.33,33.33,0,15.17,20.31,42.19,29.22,53.33,2.11,2.67,6.08,2.67,8.22,0,8.92-11.14,29.22-38.17,29.22-53.33,0-18.42-14.92-33.33-33.33-33.33Zm0,42.22c-6.14,0-11.11-4.97-11.11-11.11s4.97-11.11,11.11-11.11,11.11,4.97,11.11,11.11-4.97,11.11-11.11,11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m170.86,65.97l-32.22,12.89c-.14.33-.28.69-.42,1.03-.81,1.89-1.69,3.81-2.67,5.72v84.06l40.25-16.08c2.53-1.03,4.19-3.47,4.19-6.19v-75.22c0-4.72-4.75-7.94-9.14-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.94,122.16c-3.86-4.83-9.92-12.69-15.61-21.39v54l53.33,15.25v-69.25c-5.69,8.69-11.75,16.56-15.61,21.39-5.69,7.11-16.42,7.11-22.11,0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsiteHubColor02);
export default __webpack_public_path__ + "static/media/JobsiteHub_Color_02.39e536244fe8797cbba05cd680280843.svg";
export { ForwardRef as ReactComponent };